import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './reset.css';
import './assets/styles/variables.css';
import './assets/styles/common.css';
import './lib/growl/growl.css';
import './assets/fonts/onest/font.css';
import { Provider } from "react-redux";

import store from "./redux/store";

const container = document.querySelector('.layout');
const root = createRoot(container);
root.render(
    <Provider store={ store } >
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </Provider>
);